import {management} from '../../../index'

import {SectorRepository} from '../../infra/knex/repositories/sector'
import {ManagementRepository} from '../../infra/knex/repositories/management'
import {SectorHasFarmRepository} from '../../infra/knex/repositories/sector_has_farm'
import {SectorHasSoilRepository} from '../../infra/knex/repositories/sector_has_soil'

import {CreateSectorIdUseCase} from './createSectorUseCase'
import {ShowSectorByIdUseCase} from './showSectorByIdUseCase'
import {ShowSectorByNameUseCase} from './showSectorByNameUseCase'
import {DeleteSectorByIdUseCase} from './deleteSectorUseCase'
import {UpdateSectorIdUseCase} from './updateSectorUseCase'
import { ShowSectorsUseCase } from './showSectors'
import { ShowManagementSectorsUseCase} from './showManagementSectors'
import { CheckIfHasSectorUseCase} from './checkIfSectorExists'
import { UpdateFkEditorUseCase } from './updateFkEditorUseCase'
import { GetAllEditorsUseCase } from './getAllEditorsUseCase'


export const  managementSectorUseCases =()=>{
  const repository=new SectorRepository(management)
  const managementRepository=new ManagementRepository(management)
  const sectorHasFarmRepository=new SectorHasFarmRepository(management)
  const sectorHasSoilRepository=new SectorHasSoilRepository(management)

  const add= new CreateSectorIdUseCase(repository,sectorHasSoilRepository,sectorHasFarmRepository)
  const index=new ShowSectorByIdUseCase(repository)
  const showByName=new ShowSectorByNameUseCase(repository)
  const deleteById= new DeleteSectorByIdUseCase(repository,sectorHasSoilRepository,sectorHasFarmRepository)
  const edit= new UpdateSectorIdUseCase(repository,sectorHasSoilRepository,sectorHasFarmRepository)
  const show=new ShowSectorsUseCase(repository)
  const showManagementSectors= new ShowManagementSectorsUseCase(repository,managementRepository)
  const checkManagementSector= new CheckIfHasSectorUseCase(repository)
  const updateFkEditor = new UpdateFkEditorUseCase(repository)
  const getAllEditors = new GetAllEditorsUseCase(repository)

  return{
    add,
    index,
    showByName,
    deleteById,
    edit,
    show,
    showManagementSectors,
    checkManagementSector,
    updateFkEditor,
    getAllEditors
  }
}
